module.exports = __webpack_public_path__ + "static/media/chat-widget-bg.f4eda608.svg";